'use strict';

class NewsBar {
  constructor($sce, $scope, notificationService) {
    this.$sce = $sce;
    this.$scope = $scope;
    this.notificationService = notificationService;
  }

  $onInit() {
    this.items = [];
    this.showResults = false;
    this.getNews();
  }

  toggleShow() {
    this.showResults = !this.showResults;
  }
  markNewsAsRead(id) {
    this.notificationService.markNewsAsRead(id)
      .then((resp) => {
        this.getNews();
      });
  }

  getNews() {
    this.items = [];
    this.notificationService.getLastMonthNews()
      .then((resp) => {
        if (resp) {
          resp.map((m) => {
            m.name = this.$sce.trustAsHtml(m.name);
            m.message = this.$sce.trustAsHtml(m.message);
            this.items.push(m);
          }, this);
          if (this.items && this.items.length === 0) {
            this.showResults = false;
          }
        }
      });
  }
}

NewsBar.$inject = ['$sce', '$scope', 'notificationService'];

const newsBar = {
  bindings: {
    items: '<'
  },
  controller: NewsBar,
  template: `
    <div id="newsbar">
      <a class="nounderline" href ng-click="$ctrl.toggleShow()" style="text-decoration: none !important; color: var(--link-color);">
        <span ng-show="$ctrl.items.length > 0" class="fa-stack fa-1x has-badge" data-count="{{$ctrl.items.length}}">
          <i class="fa fa-bell fa-stack-1x"></i>
        </span>
        <span ng-show="$ctrl.items.length === 0" class="fa-stack fa-1x">
          <i class="fa fa-bell fa-stack-1x"></i>
        </span>
      </a>

      <ul ng-if="$ctrl.items.length" ng-show="$ctrl.showResults">
        <li ng-repeat="item in $ctrl.items track by $index">
            <h5 style="margin-bottom: 2px;">{{item.name}}</h5>
            <span style="margin-left: 10px;float: right;">
              <a href class="button small secondary" style="" ng-click="$ctrl.markNewsAsRead(item.id)">
                  <i class="fa fa-times" aria-hidden="true" style=""></i>
              </a>
            </span>
            <span style="font-size: smaller" ng-bind-html="item.message"></span>
        </li>
      </ul>
    </div>
  `
};

angular
  .module('sr.news', [])
  .component('newsBar', newsBar);
